module.exports = __webpack_public_path__ + "img/24.a3d5f66.jpg";